import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CetresService {

     constructor(private http: HttpClient) {
    
    }

    registrar(cetre) {
      console.log("entramos en registrar")

      return this.http.post<any>('https://vertigofin.herokuapp.com/cetres', { cetre })
        .pipe(map(confirmacion => {
       
            console.log("entramos en respuesta de regisrtrar")
            console.log(confirmacion)
            return confirmacion;
        }));
    }


}